module.exports = __webpack_public_path__ + "img/voyage_au_pays_de_la_data.863d8cd6.jpg";